import IPayload from "../interfaces/IPayload";
import { ToQueryString } from "../utils/utils";
import api from "./api";
import { resources } from "./resources";

class RebalanceUsinaHistoricoGeracao {
    async getWithFilter(filters: any) {
        return await api.get<IPayload>(
            `${resources.rebalanceUsinaHistoricoGeracao}/GetWithFilter/${ToQueryString(filters)}`
        );
    }

    async update(data: any) {
        return await api.put<any>(`${resources.rebalanceUsinaHistoricoGeracao}/Update`, data);
    }

    async create(data: any) {
        return await api.post(`${resources.rebalanceUsinaHistoricoGeracao}/Create`, data);
    }

    async createPlanoDeNegocio(data: any) {
        return await api.post(`${resources.rebalanceUsinaHistoricoGeracao}/CreatePlanoDeNegocio`, data);
    }
}

export default new RebalanceUsinaHistoricoGeracao();
